import {
  faArrowLeft,
  faCheckCircle,
  faLock,
  faPlus,
  faTachometer,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from "react-scroll";

import { useRecoilState } from "recoil";

import FormErrorBox from "../Reusable/FormErrorBox";
import FormInputField from "../Reusable/FormInputField";

import { postOrganizationCreateAPI } from "../../API/Organization";
import { topAlertMessageState, topAlertStatusState } from "../../AppState";
import { useAuthStore } from "../../stores/auth-store";
import PageLoadingContent from "../Reusable/PageLoadingContent";

function AddOrganization() {
  const [topAlertMessage, setTopAlertMessage] =
    useRecoilState(topAlertMessageState);
  const [topAlertStatus, setTopAlertStatus] =
    useRecoilState(topAlertStatusState);

  const [errors, setErrors] = useState({});
  const user = useAuthStore((store) => store.user);
  const [forceURL, setForceURL] = useState("");
  const [isFetching, setFetching] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const [email, setEmail] = useState("");
  const [organizationName, setOrganizationName] = useState("");

  const [password, setPassword] = useState("");
  const [passwordRepeated, setPasswordRepeated] = useState("");

  function onOrganizationAddSuccess(response) {
    setTopAlertStatus("success");
    setTopAlertMessage("Organization Created");
    setTimeout(() => {
      setTopAlertMessage("");
    }, 2000);

    setForceURL("/organization");
  }

  function onOrganizationAddError(apiErr) {
    setErrors(apiErr);

    setTopAlertStatus("danger");
    setTopAlertMessage("Failed");
    setTimeout(() => {
      setTopAlertMessage("");
    }, 2000);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onOrganizationAddDone() {
    setFetching(false);
  }

  const onSubmitClick = (e) => {
    const postData = {
      email: email,
      lastName: lastName,
      firstName: firstName,
      password: password,
      organizationName: organizationName,
    };

    if (organizationName.length < 5) {
      setErrors("Organization Name Must be 5 letters of above");
      return;
    }
    setErrors({});
    setFetching(true);
    postOrganizationCreateAPI(
      postData,
      onOrganizationAddSuccess,
      onOrganizationAddError,
      onOrganizationAddDone
    );
  };

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
    }

    return () => {
      mounted = false;
    };
  }, []);

  if (forceURL !== "") {
    return <Navigate to={forceURL} />;
  }

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/organization" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;Organization
                </Link>
              </li>
              <li class="is-active">
                <Link aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faPlus} />
                  &nbsp;New Organization
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/organization`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Organization
                </Link>
              </li>
            </ul>
          </nav>

          {/* Page */}
          <nav class="box">
            <p class="title is-4">
              <FontAwesomeIcon className="fas" icon={faPlus} />
              &nbsp;New Organization
            </p>
            {isFetching ? (
              <PageLoadingContent displayMessage={"Please wait"} />
            ) : (
              <>
                <FormErrorBox errors={errors} />
                <div class="columns">
                  <div class="column">
                    <FormInputField
                      label="First Name"
                      name="First Name"
                      placeholder="First Name"
                      value={user.firstName}
                      errorText={errors && errors.firstName}
                      type="text"
                      onChange={(e) => setFirstName(e.target.value)}
                      isRequired={true}
                      maxWidth="350px"
                    />
                    <FormInputField
                      label="Last Name"
                      name="Last Name"
                      placeholder="Last Name"
                      value={user.lastName}
                      errorText={errors && errors.lastName}
                      type="text"
                      onChange={(e) => setLastName(e.target.value)}
                      isRequired={true}
                      maxWidth="350px"
                    />

                    <FormInputField
                      label="Organization Name"
                      name="name"
                      minLength={5}
                      placeholder="Organization Name"
                      value={user.name}
                      errorText={errors && errors.name}
                      helpText=""
                      onChange={(e) => setOrganizationName(e.target.value)}
                      isRequired={true}
                      maxWidth="350px"
                    />

                    <FormInputField
                      label="Email"
                      name="email"
                      placeholder="Email"
                      value={email}
                      errorText={errors && errors.email}
                      helpText=""
                      onChange={(e) => setEmail(e.target.value)}
                      maxWidth="300px"
                    />

                    <div class="has-background-white-bis p-3 mb-4 is-round">
                      <p class="title is-6">
                        <FontAwesomeIcon className="fas" icon={faLock} />
                        &nbsp;Account Credentials
                      </p>
                      <p class="mb-4 has-text-grey">
                        To assign a password to the user account then please set
                        the following fields. Leave blank if you want user to
                        run forget password on account.
                      </p>
                      <FormInputField
                        label="Password (Optional)"
                        name="password"
                        type="password"
                        placeholder="Text input"
                        value={password}
                        errorText={errors && errors.password}
                        helpText=""
                        onChange={(e) => setPassword(e.target.value)}
                        isRequired={true}
                        maxWidth="380px"
                      />

                      <FormInputField
                        label="Password Repeated (Optional)"
                        name="passwordRepeated"
                        type="password"
                        placeholder="Text input"
                        value={passwordRepeated}
                        errorText={errors && errors.passwordRepeated}
                        helpText=""
                        onChange={(e) => setPasswordRepeated(e.target.value)}
                        isRequired={true}
                        maxWidth="380px"
                      />
                    </div>

                    <div class="columns">
                      <div class="column is-half">
                        <Link
                          to={`/organization`}
                          class="button is-hidden-touch"
                        >
                          <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                          &nbsp;Back
                        </Link>
                        <Link
                          to={`/organization`}
                          class="button is-fullwidth is-hidden-desktop"
                        >
                          <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                          &nbsp;Back
                        </Link>
                      </div>
                      <div class="column is-half has-text-right">
                        <button
                          onClick={onSubmitClick}
                          class="button is-primary is-hidden-touch"
                        >
                          <FontAwesomeIcon
                            className="fas"
                            icon={faCheckCircle}
                          />
                          &nbsp;Save
                        </button>
                        <button
                          onClick={onSubmitClick}
                          class="button is-primary is-fullwidth is-hidden-desktop"
                        >
                          <FontAwesomeIcon
                            className="fas"
                            icon={faCheckCircle}
                          />
                          &nbsp;Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </nav>
        </section>
      </div>
    </>
  );
}

export default AddOrganization;
